module.exports = __webpack_public_path__ + "img/back-icon.16e1a6cf.svg";